/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  LOGIN_REQUEST,
  SIGNUP_REQUEST,
  LOGOUT_REQUEST,
  GOOGLE_LOGIN_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  GET_USER_DETAIL,
  UPDATE_USER_DETAIL,
  ACTIVATE_USER,
  UPDATE_USER_PASSWORD,
  SAVE_INVESTOR_PROFILE,
  UPDATE_INVESTOR_PROFILE,
  SAVE_FILTER,
  SET_CURRENT_FILTER,
  GET_CURRENT_FILTER
} from "./authActionTypes";
import {
  RESEND_EMAIL,
  SAVE_REDIRECT,
  SET_CONTACT_TO_ADD,
  RESET_DOCUMENTS
} from "../actionTypes";

export const signup = (userData, dispatch) => {
  dispatch({
    type: SIGNUP_REQUEST,
    payload: userData
  });
};

export const login = (userData, dispatch) => {
  dispatch({
    type: LOGIN_REQUEST,
    payload: userData
  });
  //  Reset all other states
  // dispatch({ type: RESET_RESEND_EMAIL });
  // dispatch({ type: RESET_FORGOT_PASSWORD })
};

//call this function with dispatch(logout());
export const logout = dispatch => {
  // Remove token from localStorage
  localStorage.removeItem("token");
  localStorage.clear();
  // Remove auth header for future requests
  // setAuthToken(null);
  // Set current user to {} which will set isAuthenticated to false
  dispatch({
    type: LOGOUT_REQUEST
  });

  dispatch({
    type: RESET_DOCUMENTS
  });
};

export const logoutMalformed = () => {
  // Remove token from localStorage
  localStorage.removeItem("token");
  // Remove auth header for future requests
  // setAuthToken(null);
  // Set current user to {} which will set isAuthenticated to false
};

export const activateUser = (userData, dispatch) => {
  dispatch({
    type: ACTIVATE_USER,
    payload: userData
  });
};

export const googleLogin = (gtoken, dispatch) => {
  dispatch({
    type: GOOGLE_LOGIN_REQUEST,
    payload: gtoken
  });
};
export const forgotpassword = (userData, dispatch) => {
  dispatch({
    type: FORGOT_PASSWORD_REQUEST,
    payload: userData
  });
};

export const resetpassword = (userData, dispatch) => {
  dispatch({
    type: RESET_PASSWORD_REQUEST,
    payload: userData
  });
};

export const getUserDetail = dispatch => {
  dispatch({
    type: GET_USER_DETAIL
  });
};

export const updateUser = (userData, dispatch) => {
  dispatch({
    type: UPDATE_USER_DETAIL,
    payload: userData
  });
};

export const updatePassword = (userData, dispatch) => {
  dispatch({
    type: UPDATE_USER_PASSWORD,
    payload: userData
  });
};

export const resendEmail = (email, dispatch) => {
  dispatch({
    type: RESEND_EMAIL,
    payload: email
  });

  // dispatch({type: RESET_LOGIN });
  // dispatch({type: RESET_FORGOT_PASSWORD})
};

export const saveRedirect = (route, dispatch) => {
  dispatch({
    type: SAVE_REDIRECT,
    payload: route
  });
};

export const setContactToAdd = (contact, dispatch) => {
  dispatch({
    type: SET_CONTACT_TO_ADD,
    payload: contact
  });
};

export const saveInvestorProfile = (data, dispatch) => {
  dispatch({
    type: SAVE_INVESTOR_PROFILE,
    payload: data
  });
};
export const updateInvestorProfile = (data, dispatch) => {
  dispatch({
    type: UPDATE_INVESTOR_PROFILE,
    payload: data
  });
};

export const saveFilter = (data, dispatch) => {
  dispatch({
    type: SAVE_FILTER,
    payload: data
  });
};

export const setCurrentFilter = (data, dispatch) => {
  dispatch({
    type: SET_CURRENT_FILTER,
    payload: data
  });
};

export const getCurrentFilter = (data, dispatch) => {
  dispatch({
    type: GET_CURRENT_FILTER,
    payload: data
  });
};
